import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TablePurchaseRequestor from "./components/tables/TablePurchaseRequestor";

function PurchaseRequestorRegister() {
  return (
    <ToastProvider>
      <Dashboard>
        <TablePurchaseRequestor />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default PurchaseRequestorRegister;